module.exports = __webpack_public_path__ + "static/media/1_4.6124791a.png";